export default __webpack_public_path__ + "static/media/HONGQI.9a83f904.png";